import React, { useState } from "react";
import { Chip, Grid } from "@mui/material";
import CategoryPool from "./categoryPool";
import CategoryBracket from "./categoryBracket";

function TournamentCategoryMatch ({
    tournamentId,
    categoriesOptions, type
}) {

    const [selectedCategories, setSelectedCategories] = useState(categoriesOptions[0]?.value || null); // array of values

    const toggleCategoryPill = (val) => {
        console.log('here catxxx-ss', val)
        setSelectedCategories(val);    // always exactly one
    };

    return (
        <Grid container p={1} gap={0.5}>
            {categoriesOptions.map(cat => {
                console.log('here catxxx', cat, selectedCategories)
                const selected = selectedCategories == cat.value;
                return (
                <Chip
                    key={cat.value}
                    label={cat.label}
                    size="small"
                    onClick={() => toggleCategoryPill(cat.value)}
                    color={selected ? "primary" : "default"}
                    variant={selected ? "filled" : "outlined"}
                />
                );
            })}
            {
                (type == "pool") &&
                <Grid item xs={12}>
                    <CategoryPool tournamentId={tournamentId} category={selectedCategories}/>
                </Grid>
            }
            {
                (type == "bracket") &&
                <Grid item xs={12}>
                    <CategoryBracket tournamentId={tournamentId} category={selectedCategories}/>
                </Grid>
            }
        </Grid>
    )
}

export default TournamentCategoryMatch